module.exports = __webpack_public_path__ + "img/auth-cover-img.43d8c28a.svg";